import { render, staticRenderFns } from "./DeviceIntegrationsConfig.vue?vue&type=template&id=225b2210&scoped=true&"
import script from "./DeviceIntegrationsConfig.vue?vue&type=script&lang=js&"
export * from "./DeviceIntegrationsConfig.vue?vue&type=script&lang=js&"
import style0 from "./DeviceIntegrationsConfig.vue?vue&type=style&index=0&id=225b2210&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225b2210",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('225b2210')) {
      api.createRecord('225b2210', component.options)
    } else {
      api.reload('225b2210', component.options)
    }
    module.hot.accept("./DeviceIntegrationsConfig.vue?vue&type=template&id=225b2210&scoped=true&", function () {
      api.rerender('225b2210', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/device/DeviceIntegrationsConfig.vue"
export default component.exports